import { render } from "./textarea.vue?vue&type=template&id=01307cda"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/input-only/textarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01307cda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01307cda', __exports__)) {
    console.log('reload')
    api.reload('01307cda', __exports__)
  }
  
  module.hot.accept("./textarea.vue?vue&type=template&id=01307cda", () => {
    console.log('re-render')
    api.rerender('01307cda', render)
  })

}


export default __exports__